import React, {Component} from "react";
import {api, apis, msg, rd, sendGet, throws, type_channel} from "../../../vars/rd";
import {preloaderHide, preloaderShow} from "../../../libs/redux/actions/preloader";
import {connect} from "react-redux";
import {favoriteChange} from "../../../libs/redux/actions/favorite";

/**
 * 채널 즐겨찾기 채널
 */
class ChannelFavorite extends Component {
    constructor(props) {
        super(props);

        this.msg = msg();

        this.type = props.type;
        this.callback = props.callback;

        this.state = {
            channel: props.id,
            selected: props.selected,
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        // 채널 변경시 정보 업데이트
        try {
            if(this.props.id !== prevProps.id || this.props.type !== prevProps.type) {
                this.setState({
                    channel: this.props.id,
                    selected: this.props.selected,
                });
            }
        } catch (e) {}

        try {
            const favorite = this.props && this.props.hasOwnProperty('favorite') ? this.props.favorite : false;
            if(favorite && this.props.id === favorite.id) {
                const selected = favorite.selected;
                if(this.state.selected !== selected)
                    this.setState({selected});
            }
        } catch (e) {}
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    /**
     * 즐겨찾기
     * @param e
     */
    async favorite(e) {
        e.stopPropagation();

        this.dispatch(preloaderShow());
        try {
            const next_state = !this.state.selected;
            const url = api(apis.channel_favorite, {
                serviceid: rd.user.serviceid,
                groupid: rd.user.groupid,
                chid: this.state.channel,
            });
            const json = await sendGet(url);
            if(this.mounted) {
                if(!json || json.result !== "OK") throws(msg().api_fail);
                if(json.status === "OK") {
                    this.callbackCall(next_state);
                }
            }
        } catch (err) {
        } finally {
            this.dispatch(preloaderHide());
        }
    }

    get isFavorite() {
        try {
            return this.state.selected;
        } catch (e) {}
        return false;
    }

    callbackCall(state) {
        if(this.callback) {
            this.callback.call(null, state);
        }

        if(this.dispatch) {
            // 전역 이벤트 전송
            this.dispatch(favoriteChange(this.state.channel, state));
        }
    }

    render() {
        switch (this.type) {
            // 추천채널
            case type_channel.recommand:
                return (
                    <span onClick={e => this.favorite(e)}>
                        <img src={`/images/icon-book-type1${this.isFavorite ? '_on' : ''}.png`} alt={'즐겨찾기'} />
                    </span>
                );
            // Channel Detail
            case type_channel.detail:
                return (
                    <div className="btn-m btn-s1" onClick={e => this.favorite(e)}>
                        <img src={`/images/icon-book-type1${this.isFavorite ? '_on' : ''}.png`} alt='내 채널에 저장'/>
                        <span><img src="/images/icon-popup-add.png" alt="내 채널에 저장" />내 채널에 저장</span>
                    </div>
                );

            // 플레이어용 스킨
            case type_channel.player:
                return (
                    <div className="channel-like-icon hide">
                       <span onClick={e => this.favorite(e)}>
                           <img src={`/images/icon-book-type2${this.isFavorite ? '_on' : ''}.png`} alt="좋아요"/>
                       </span>
                    </div>
                );

            // 기본 스킨
            case type_channel.default:
                return (
                    <span onClick={e => this.favorite(e)}>
                        <img src={`/images/icon-book-type3${this.isFavorite ? '_on' : ''}.png`} alt={'즐겨찾기'} />
                    </span>
                );

            default:
                return null;
        }
    }
}

const favoriteStateToProps = (state) => {
    return {
        favorite: state.favorite
    };
};

export default connect(favoriteStateToProps)(ChannelFavorite);


// WEBPACK FOOTER //
// ./src/pages/components/buttons/channel.favorite.jsx